import { useState } from "react";
import Organization from "./Organization";
import User from "./User";
import Module from "./Module";
import Access from "./Access";
import { Link, useLocation } from 'react-router-dom';



const Admin = (props) => {
  const [visibleSection, setVisibleSection] = useState("organization");

  const handleButtonClick = (section) => {
    setVisibleSection(section);
  };

  return (
    <div className="h-screen overflow-y-auto static">



      <nav class="  w-full z-20 top-0 start-0 bg-white">
        <div class="flex items-center justify-between mx-auto px-12 py-0.5">
          <Link to="/">
            <img src="./images/OnehumLogoDark.png" class="h-10" alt="Onehum Logo" />

          </Link>
          <h2 className="font-bold text-2xl text-blue-900">Admin Portal</h2>
          <div class="flex">


            <p className="text-gray-400 font-semibold text-sm text-center  rounded-lg py-1.5 px-1.5">
              Welcome
              <span className="block font-normal text-sm cursor-pointer text-gray-600">
                {props.user.firstName} {props.user.lastName}
              </span>
            </p>
          </div>

        </div>
      </nav>

      {/* Buttons */}
      <div className="flex space-x-4 mb-6 mt-4 px-6">
        <button
          className={`px-4 py-2 border-2 rounded transition-colors duration-300 ${visibleSection === "organization"
            ? "bg-blue-500 text-white border-blue-500"
            : "bg-transparent text-blue-500 border-blue-500"
            }`}
          onClick={() => handleButtonClick("organization")}
        >
          Organization
        </button>
        <button
          className={`px-4 py-2 border-2 rounded transition-colors duration-300 ${visibleSection === "module"
            ? "bg-green-500 text-white border-green-500"
            : "bg-transparent text-green-500 border-green-500"
            }`}
          onClick={() => handleButtonClick("module")}
        >
          Module
        </button>
        <button
          className={`px-4 py-2 border-2 rounded transition-colors duration-300 ${visibleSection === "user"
            ? "bg-red-500 text-white border-red-500"
            : "bg-transparent text-red-500 border-red-500"
            }`}
          onClick={() => handleButtonClick("user")}
        >
          User
        </button>
        <button
          className={`px-4 py-2 border-2 rounded transition-colors duration-300 ${visibleSection === "access"
            ? "bg-yellow-400 text-white border-yellow-400"
            : "bg-transparent text-yellow-400 border-yellow-400"
            }`}
          onClick={() => handleButtonClick("access")}
        >
          Access
        </button>
      </div>

      {/* Sections */}
      {visibleSection === "organization" && (
        <Organization />
      )}
      {visibleSection === "module" && (
        <Module />
      )}
      {visibleSection === "user" && (
        <User />
      )}
      {visibleSection === "access" && (
        <Access />
      )}
    </div>
  );
};

export default Admin;
